"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GeocoderType;
(function (GeocoderType) {
    GeocoderType["Google"] = "Google";
    GeocoderType["Yandex"] = "Yandex";
    GeocoderType["Bing"] = "Bing";
    GeocoderType["OSM"] = "OSM";
    GeocoderType["SeDi"] = "SeDi";
    GeocoderType["OSRM"] = "OSRM";
    GeocoderType["Nominatim"] = "Nominatim";
})(GeocoderType = exports.GeocoderType || (exports.GeocoderType = {}));
//# sourceMappingURL=types.js.map